import React from 'react';
import Box from '@amzn/meridian/box';
import Row from '@amzn/meridian/row';
import Icon from '@amzn/meridian/icon';
import filterTokens from '@amzn/meridian-tokens/base/icon/filter';
import { useIntl } from 'react-intl';
import SearchField from '@amzn/meridian/search-field/search-field';
import { css } from '@emotion/css';

interface AllAssociatesBannerProps {
  searchValue: string | undefined;
  onSearchValueChange: (value: string) => void;
  onSearchSubmit: () => void;
  onToggleSidebars?: () => void;
}

const filtersContainer = css`
  background-color: #f7f6f8;
  width: 100%;
  display: inline-flex;
  margin-bottom: 15px !important;
  border-radius: 5px;
  padding-top: 28px;
  padding-bottom: 28px;
`;

const AllAssociatesBanner: React.FC<AllAssociatesBannerProps> = ({
  searchValue,
  onSearchValueChange,
  onSearchSubmit,
  onToggleSidebars,
}) => {
  const intl = useIntl();
  return (
    <Box spacingInset='400' className={filtersContainer}>
      <Row
        alignmentVertical='center'
        alignmentHorizontal='justify'
        width='100%'
      >
        {/* Search bar and filters button section - left aligned */}
        <Box>
          <Row alignmentVertical='center' spacing='400'>
            <SearchField
              value={searchValue}
              onChange={onSearchValueChange}
              placeholder={intl.formatMessage({
                id: 'cs_perfportal_training_search_for',
                defaultMessage: 'Search for...',
              })}
              onSubmit={onSearchSubmit}
              width={300}
            />
            {!!onToggleSidebars ? (
              <div onClick={onToggleSidebars} style={{ cursor: 'pointer' }}>
                <Icon tokens={filterTokens} />
              </div>
            ) : (
              <></>
            )}
          </Row>
        </Box>
      </Row>
    </Box>
  );
};

export default AllAssociatesBanner;
